<app-bringoz-state-link appBringozIdGenerator="supplyAccountLink"
                        permission="accounts.supply.get"
                        state="accounts-detail-supply.info.preferences"
                        [params]="params()"
                        [text]="account()?.name">
</app-bringoz-state-link>
